import clsx from "clsx";
import React from "react";

type ShortcutKbdProps = {
   /** Shortcut text, e.g. "⌘K", "Ctrl+G", "Esc". */
   shortcut: string;
   /** Color overrides (border/bg/text); structural classes stay shared. */
   className?: string;
};

/**
 * Keyboard-hint chip used across the sidebar (nav search's ⌘K, the
 * assistant entry's ⌘G, the search dialog's Esc). Single source of truth so
 * every hint has identical sizing, font, and spacing. The ⌘ glyph renders a
 * step larger than the letters, matching how it reads in native menus.
 */
const ShortcutKbd: React.FC<ShortcutKbdProps> = ({shortcut, className}) => {
   const hasCommandGlyph = shortcut.startsWith("⌘");

   return (
      <kbd
         className={clsx(
            "pointer-events-none inline-flex h-5 shrink-0 select-none items-center gap-1",
            "rounded border px-1.5 font-mono text-[10px] font-medium",
            className ?? "border-200 bg-200 text-400"
         )}
      >
         {hasCommandGlyph ? (
            <>
               <span className="text-xs">⌘</span>
               {shortcut.slice(1)}
            </>
         ) : (
            shortcut
         )}
      </kbd>
   );
};

export default ShortcutKbd;
